import { Inject, Injectable, LOCALE_ID, Optional } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject, of, from } from 'rxjs';
import { MessagerService } from '@farris/ui-messager';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { LanguageService } from './languag.service';
import { ServerExceptionEntity, ExceptionFactory, IExceptionStrategy } from './error/index';
import { BsModalRef } from '@farris/ui-modal';
import moment from 'moment';
import { DeviceAbility } from './util/device-ability';

/**
 * è¡¨åæ¶æ¯æå¡
 * @scope FormModule
 * @summary
 * 1ãåè£@farris/uiçæ¶æ¯æå¡ï¼
 * 2ãæä¾éå¯¹è¡¨åçå¿«æ·æ¹æ³ï¼
 */
@Injectable()
class FormMessageService {

  /**
   * æé å½æ°
   * æ³¨å¥@farris/uiçLoadingService
   */
  constructor(
    private messagerService: MessagerService,
    @Optional() private languageService: LanguageService,
    @Inject(LOCALE_ID) private curLanguage: string, // ä¸ºäºç¬ç«å¼¹åºéæ°ç»å½æç¤ºæ¡ï¼åæ¢å°è¿è¡æ¡æ¶httpæå¡åå¯ä»¥å é¤
  ) {
    this.languageService = this.languageService || LanguageService.getInstance();
  }
  /**
   * questionå¼¹çª
   */
  public question(content: string): Observable<boolean> {
    const confirmResult$: Promise<boolean> = this.confirmPromise(content);
    return from(confirmResult$);
  }

  /**
   * å¸¦é»è®¤ç¦ç¹çå¼¹åºæç¤º
   * @param content åå®¹
   */
  public question2(content: string): Observable<boolean> {
    const promise$: Promise<boolean> = new Promise((resolve, reject) => {
      const dialogRef = this.messagerService.question2(
        content,
        [
          {
            text: this.languageService.no,
            cls: 'btn btn-secondary',
            handle: () => {
              resolve(false);
              dialogRef.close();
            }
          },
          {
            text: this.languageService.yes,
            cls: 'btn btn-primary',
            defaultFocus: true,
            handle: () => {
              resolve(true);
              dialogRef.close();
            }
          }
        ]);
    });
    return from(promise$);
  }

  /**
   * å¼¹åºè¾å¥å¯¹è¯æ¡
   * @param title æ é¢
   */
  public prompt(title: string): Observable<any> {
    return this.messagerService.prompt(title);
  }

  /**
   * ä½¿ç¨Promiseå®ä¾åè£åè°æ¹æ³ï¼ä»¥åæ­¥åè°æ¹æ³æ§è¡åç»æ
   * @param content
   */
  private confirmPromise(content: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.messagerService.question(
        content,
        () => { resolve(true); },
        () => { resolve(false); }
      );
    });
  }

  /**
   * ç¡®è®¤å¼¹æ¡
   * @param content å¼¹åºåå®¹æç¤º
   */
  public confirm(content: string): Observable<boolean> {
    return this.messagerService.confirm(content);
  }

  /**
   * æ¶æ¯å¼¹æ¡
   */
  public info(content: string) {
    this.messagerService.info(content);
  }

  /**
   * éè¯¯å¼¹æ¡
   */
  public error(content: string) {
    this.messagerService.error(content);
  }

  /**
   * è­¦åå¼¹æ¡
   */
  public warning(content: string) {
    this.messagerService.warning(content);
  }

  /**
   * æå¡å¨ç«¯å¼å¸¸æç¤ºå¼¹æ¡
   */
  public httpErrorInServer(httpError: HttpErrorResponse): void {
    let error: ServerExceptionEntity = httpError.error;
    if (typeof (error) === 'string') {
      try {
        error = JSON.parse(error);
      } catch (e) { }
    }
    if (!error || error.Level == null || error.Level == undefined) { // æªå°è£errorææªè®¾ç½®å¼å¸¸ç­çº§
      this.messagerService.error(httpError.message);
      return;
    }
    const exceptionStrategy: IExceptionStrategy = ExceptionFactory.getInstance(this.messagerService, this.languageService).getExceptionHandleStrategy(error.Level);
    exceptionStrategy.handleException(error);
  }

  /**
   * å®¢æ·ç«¯å¼å¸¸æç¤ºå¼¹æ¡
   */
  public httpErrorInClient(httpError: HttpErrorResponse): void {
    if (!httpError) {
      return;
    }
    const error = httpError.error;
    const message = httpError.error && httpError.error.error && httpError.error.error.message;
    const exceptionMsg: string = message || httpError.message && httpError.message.replace(/http:\/\/[a-zA-Z0-9.:]{1,}/, '');

    const date = error.date || new Date();
    const localDate = moment(date).format('YYYY-MM-DD HH:mm:ss');

    let bsModalRef: BsModalRef = null;
    const options = {
      // title: this.languageService.serverNotifyTitle,
      showMaxButton: false,
      buttons: [
        {
          text: this.languageService.roger,
          cls: 'btn btn-primary btn-lg',
          handle: () => {
            bsModalRef.close();
          }
        }
      ],
      // showHeader: false,
      width: 440,
      height: 200,
      safeHtml: false,
      exception: {
        date: localDate,
        message: exceptionMsg,
        copyButton: {
          text: this.languageService.copy,
          onClick: (e) => {
            const result = DeviceAbility.copyToClipboard(exceptionMsg);
            const text = result ? this.languageService.copySuccess : this.languageService.copyFailed;
            bsModalRef.content.showMiniNotify(text, 1500);
          }
        }
      }
    };
    const title = exceptionMsg.length > 100 ? exceptionMsg.substring(0, 100) + '...' : exceptionMsg;
    bsModalRef = this.messagerService.show('exception', title, options);
  }

  /**
   * 401å¼å¸¸å¤ç
   * ä¸ºäºç¬ç«å¼¹åºéæ°ç»å½æç¤ºæ¡ï¼åæ¢å°è¿è¡æ¡æ¶httpæå¡åå¯ä»¥å é¤
   * @param httpError å¼å¸¸
   */
  public http401Error(httpError: HttpErrorResponse): void {
    const dialogShownKey = '401ErrorShownFlag';

    if (!httpError || window[dialogShownKey]) {
      return;
    }

    const i18n = {
      'en': {
        title: 'Warning',
        sessionInvalid: 'Your login has expired, please login again.',
        ok: 'ok',
        cancel: 'cancel'
      },
      'zh-CHS': {
        title: 'æç¤º',
        sessionInvalid: 'ç¨æ·ç»å½ä¿¡æ¯å·²å¤±æï¼æ¯å¦éæ°ç»å½?',
        ok: 'ç¡®è®¤',
        cancel: 'åæ¶'
      }
    };
    this.curLanguage = this.curLanguage || 'zh-CHS';

    const messageOptions = {
      title: i18n[this.curLanguage].title,
      initialState: {
        okText: i18n[this.curLanguage].ok,
        okHandle: () => {
          modalRef.close();
          window[dialogShownKey] = false;
          const eventResult = httpError && httpError.error || {};
          const redirectUri = eventResult.redirect_uri || '/login.html';
          window.location.href = `/logout.html#?logout-before-redirect=true&loginUri=${redirectUri}`;
        },
        cancelText: i18n[this.curLanguage].cancel,
        cancelHandle: () => {
          modalRef.close();
          window[dialogShownKey] = false;
        }
      },
      showHeader: true,
      width: 420,
      height: 180,
      fitContent: false
    };
    const modalRef = this.messagerService.show('question', i18n[this.curLanguage].sessionInvalid, messageOptions);
    window[dialogShownKey] = true;
    if (modalRef && modalRef.dialog && modalRef.dialog.instance.closed) {
      modalRef.dialog.instance.closed.subscribe(() => {
        window[dialogShownKey] = false;
      });
    }
  }
}

export { FormMessageService };

